module.exports = __webpack_public_path__ + "img/textBg.67d8c895.webp";